import useFeedbackRecordingStore from '@/stores/feedbackRecording/feedbackRecordingStore';
import FlagFilledIcon from '@/shared/icons/FlagFilledIcon';
import IconWrapper from '@/shared/components/UI/IconWrapper';

const FeedbackRecordingButton = ({ getRecordingEvents }) => {
  const openModal = useFeedbackRecordingStore((s) => s.openModal);
  const errorContext = useFeedbackRecordingStore((s) => s.errorContext);
  const clearErrorContext = useFeedbackRecordingStore((s) => s.clearErrorContext);

  const hasError = !!errorContext;

  const handleClick = () => {
    if (hasError) clearErrorContext();
    openModal(getRecordingEvents);
  };

  return (
    <button
      onClick={handleClick}
      className="flex items-center rounded-lg p-v3-xxs gap-v3-xxs"
      title={hasError ? 'Report Error' : 'Feedback'}
    >
      <IconWrapper size={20}>
        <FlagFilledIcon className="text-v3-red-primary" />
      </IconWrapper>
      <p className={`hidden sm:block whitespace-nowrap text-v3-h10 font-medium leading-4  ${hasError ? 'text-v3-red-primary' : 'text-v3-gray-secondary'}`}>
        {hasError ? 'Report Error' : 'Feedback'}
      </p>
    </button>
  );
};

export default FeedbackRecordingButton;
